import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker, {
  DateObject,
  getAllDatesInRange,
} from "react-multi-date-picker";
import { persianToEnglishDigitConverter } from "src/utils/persianToEnglishDigitConverter";
import "react-multi-date-picker/styles/layouts/mobile.css"


export default function FilterColumn({
  setFilterValue,
  type,
  possibleChoices,
  column,
  table,
  backendFilters,
  setBackendFilters
}) {


  switch (type) {
    case "null":
      return <></>;
    case "array":
    case "string":
      return (
        <input
          className="rounded-md w-full border-b border-solid border-gray-200 focus:border-gray-400 !py-2 bg-[#f5f8fa] dark:bg-[#111111] !p-1"
          placeholder={`فیلتر با ...`}
          onChange={(e) => setFilterValue(e.target.value)}
        />
      );
    case "number":
      return (
        <div>
          <div className="flex gap-3">
            <input
              type="number"
              onChange={(value) => setFilterValue((old) => [value, old?.[1]])}
              placeholder={`حداقل`}
              className="w-full border-b border-solid border-gray-200 focus:border-gray-400 py-2"
            />
            <input
              type="number"
              onChange={(value) => setFilterValue((old) => [old?.[0], value])}
              placeholder={`حداکثر`}
              className="w-full border-b border-solid border-gray-200 focus:border-gray-400 py-2"
            />
          </div>
          <div className="h-1" />
        </div>
      );
    case "date":
      return (
        <div className="flex gap-2">
          <DatePicker
            style={{
              width: "100%",
              height: "36px",
              borderRadius: "0",
              border: "none",
              borderBottom: "1px solid #e5e7eb",
            }}
            placeholder={"از ..."}
            onChange={(value) => {
              setFilterValue((old) => [
                persianToEnglishDigitConverter(value?.format("YYYY/MM/DD")),
                old?.[1],
              ]);
            }}
            calendar={persian}
            locale={persian_fa}
            format="YYYY/MM/DD"
            className="rmdp-mobile"
          />

          <DatePicker
            style={{
              width: "100%",
              height: "36px",
              borderRadius: "0",
              border: "none",
              borderBottom: "1px solid #e5e7eb",
            }}
            placeholder={"تا ..."}
            onChange={(value) => {
              setFilterValue((old) => [
                old?.[0],
                persianToEnglishDigitConverter(value?.add("1", "days")?.format("YYYY/MM/DD")),
              ]);
            }}
            calendar={persian}
            locale={persian_fa}
            format="YYYY/MM/DD"
            className="rmdp-mobile"
          />
        </div>
      );
    default:
      if (possibleChoices) {
        return (
          <select
            className="rounded-md w-full border-b border-solid border-gray-200 focus:border-gray-400 !py-2 bg-[#f5f8fa] dark:bg-[#111111] !p-1"
            onChange={(e) => setFilterValue(e.target.value)}
          >
            <option value="all">همه</option>
            {possibleChoices.map(function (single) {
              return <option value={single.value}>{single.title}</option>;
            })}
          </select>
        );
      }
      break;
  }
}
